export abstract class AuthAbstract {
  abstract partner: string;
  abstract accType: string;
  abstract getSLTToken(): Promise<null | string>;
  abstract getPartnerAuthFromCookie(): string;
  abstract saveTMAuth(tmAuth: string): void;
  abstract getTMAuthFromCookie(): string;
  abstract getTMAuth(): Promise<string | null>;
  abstract saveTMAuthInCookie(tmAuth: string): void;
}
